<sc-sub-title><sc-dictionary-label
    dictionaryKey="tmc-yard.access.ui.entrance-leave-dialog.hints-title"></sc-dictionary-label></sc-sub-title>
<sc-content-spacer vertical></sc-content-spacer>
<sc-no-data compact *ngIf="checks == null || checks.length == 0"></sc-no-data>
<div *ngFor="let check of checks; let i = index">
  <sc-content-spacer vertical *ngIf="i > 0"></sc-content-spacer>
  <div class="hint {{check.state}}">
    <sc-padding>
      <sc-flex>
        <sc-icon iconClass="{{getIconForState(check.state)}} fa-2x"></sc-icon>
        <sc-content-spacer></sc-content-spacer>
        <sc-dictionary-label [dictionaryKey]="check.nameDictionaryKey"></sc-dictionary-label>
      </sc-flex>
      <ng-container *ngIf="check.descriptionDictionaryKey">
        <sc-content-spacer half></sc-content-spacer>
        <sc-hint>
          <sc-dictionary-label [dictionaryKey]="check.descriptionDictionaryKey"></sc-dictionary-label>
        </sc-hint>
      </ng-container>
    </sc-padding>
  </div>
</div>
